<script>
	import { flip } from "svelte/animate";
	import { state } from "../store";
	import Me from "./me.svelte";
	import Player from "./player.svelte";

	$: isAdmin = $state.isAdmin;
	$: players = $state.players.sort((a, b) => {
		return b.points - a.points;
	});
	$: me = players.find((player) => {
		return player.isYou;
	});
</script>

<div>
	{#each players as player (player.id)}
		<div animate:flip={{ duration: 300 }}>
			<Player {player} showSolution={isAdmin || (me && me.solved)} />
		</div>
	{/each}
</div>

<style>
</style>
